import React from 'react';
import {render} from 'react-dom';
import {ThemeProvider} from '@spothero/ui';

import ParkingWidget from './ParkingWidget';

window.shParkingWidgetInit = affiliateData => {
    render(
        <ThemeProvider resetCSS={false}>
            <ParkingWidget affiliateData={affiliateData} />
        </ThemeProvider>,
        document.getElementById('SH-parking-widget-root')
    );
};
